document.addEventListener("turbolinks:load", function() {
  const resetButton = document.querySelector('[type="reset"]')

  if(resetButton) {
    const form = resetButton.form
    const selectInputs = form.querySelectorAll('select')
    const textInputs = form.querySelectorAll('input[type="text"]')
    const numberInputs = form.querySelectorAll('input[type="number"]')

    resetButton.addEventListener('click', (event) => {
      form.reset();

      textInputs.forEach((input) =>{
        input.value = ''
      })

      numberInputs.forEach((input) => {
        input.value = ''
      })

      selectInputs.forEach((select) => {
        Array(...select.options).forEach((option) => {
          option.removeAttribute('selected');
        })
      })

      form.submit()
    })
  }
})

